
export default {
  lg: '1199px',
  md: '991px',
  sm: '767px',
  xs: '556px',
};
